module.exports = __webpack_public_path__ + "static/media/ujevn.05eede4f.m4a";